import { CalendarClock } from 'lucide-react';
import { MeetingNotesTab } from '../../meetingNotes/MeetingNotesTab';

/**
 * CLE-205 — Meeting Notes section for the lead detail page.
 *
 * Leads are simpler than clients/projects (no separate tab), so meeting notes
 * render as an inline section after Actions, mirroring the LeadActions header
 * style. The shared MeetingNotesTab is light-themed, so it sits inside a light
 * panel embedded in the dark lead layout. Action items for leads surface as
 * LeadActions via the backend ingestion pipeline.
 */
export function LeadMeetingNotesSection({ leadId }: { leadId: string }) {
  return (
    <section className="mt-8">
      <div className="mb-3 flex items-center gap-2 text-[13px] font-semibold text-gray-700">
        <CalendarClock size={15} className="text-gray-500" />
        Notițe de întâlnire &amp; Interacțiuni
      </div>
      <div className="rounded-lg border border-gray-200 bg-white p-4 text-gray-900">
        <MeetingNotesTab owner={{ leadId }} variant="tab" />
      </div>
    </section>
  );
}
